import { useEffect, useMemo, useState } from "react";
import { useDispatch } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import {
  setQuickPayPageActiveButton,
  setShowQuickPayDetails,
} from "../../../../features/QuickPaySlice";
import { settingData } from "../../../store/slices/appSlice";

export default function useSidebarNavigation(onNavigate) {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const [activeKey, setActiveKey] = useState(
    () => sessionStorage.getItem("navClick") || "",
  );

  useEffect(() => {
    const slug = location.pathname.replace(/^\/+/, "").split("/")[0];
    if (!slug) return;

    setActiveKey(slug);
    sessionStorage.setItem("navClick", slug);
  }, [location.pathname]);

  const actions = useMemo(
    () => ({
      goTo(route, activeValue, routeState) {
        const normalizedRoute = String(route || "").replace(/^\/+/, "");
        const nextActiveKey = activeValue || normalizedRoute;

        sessionStorage.setItem("navClick", nextActiveKey);
        dispatch(setShowQuickPayDetails(false));
        dispatch(setQuickPayPageActiveButton({ name: "QuickPay" }));
        if (normalizedRoute === "cardssettings") {
          dispatch(settingData({ field: "cardsMode", value: "cards" }));
          dispatch(settingData({ field: "cardsEditingCardId", value: null }));
        }
        setActiveKey(nextActiveKey);
        navigate(`/${normalizedRoute}`, routeState ? { state: routeState } : undefined);
        onNavigate?.();
      },
      setActiveKey,
    }),
    [dispatch, navigate, onNavigate],
  );

  return { activeKey, ...actions };
}
